import React from 'react';
import { Card, Statistic, Row, Col, Empty } from 'antd';
import { 
  TrophyOutlined, 
  RiseOutlined, 
  FallOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';
import './DoublesBasicStats.css';

/**
 * 双打基础统计组件
 * 展示双打比赛的基础统计数据：胜负、得分等
 */
const DoublesBasicStats = ({ statistics, loading }) => {
  if (loading) {
    return (
      <div className="doubles-basic-stats loading">
        <div className="loading-text">加载中...</div>
      </div>
    );
  }

  if (!statistics || !statistics.doubles) {
    return (
      <div className="doubles-basic-stats empty">
        <Empty description="暂无双打统计数据" />
      </div>
    );
  }

  const { doubles } = statistics;

  return (
    <div className="doubles-basic-stats">
      <div className="stats-header">
        <h3 className="stats-title">双打基础统计</h3>
      </div>

      <Row gutter={[16, 16]} className="stats-row">
        {/* 比赛场次 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="比赛场次"
              value={doubles.matches || 0}
              prefix={<TrophyOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        {/* 胜场 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="胜场"
              value={doubles.wins || 0}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>

        {/* 负场 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="负场"
              value={doubles.losses || 0}
              prefix={<CloseCircleOutlined />}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Card>
        </Col>

        {/* 胜率 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="胜率"
              value={doubles.winRate || 0}
              suffix="%"
              prefix={<RiseOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>

        {/* 总得分 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="总得分"
              value={doubles.pointsScored || 0}
              prefix={<RiseOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        {/* 总失分 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="总失分"
              value={doubles.pointsLost || 0}
              prefix={<FallOutlined />}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Card>
        </Col>

        {/* 净得分 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="净得分"
              value={doubles.netPoints || 0}
              prefix={doubles.netPoints >= 0 ? <RiseOutlined /> : <FallOutlined />}
              valueStyle={{ 
                color: doubles.netPoints >= 0 ? '#52c41a' : '#ff4d4f' 
              }}
            />
          </Card>
        </Col>

        {/* 平均每场得分 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="平均得分"
              value={doubles.avgPointsScored || 0}
              prefix={<RiseOutlined />}
              precision={1}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        {/* 平均每场失分 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="平均失分"
              value={doubles.avgPointsLost || 0}
              prefix={<FallOutlined />}
              precision={1}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Card>
        </Col>

        {/* 平均每场净得分 */}
        <Col xs={12} sm={8} md={6}>
          <Card className="stat-card">
            <Statistic
              title="平均净得分"
              value={doubles.avgNetPoints || 0}
              prefix={doubles.avgNetPoints >= 0 ? <RiseOutlined /> : <FallOutlined />}
              precision={1}
              valueStyle={{ 
                color: doubles.avgNetPoints >= 0 ? '#52c41a' : '#ff4d4f' 
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DoublesBasicStats;

